/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { Button, AvailabilityTypes } from 'sarsaparilla';
import DetailedAvailabilityActions from '../../../shared-components/detailed-availability/DetailedAvailabilityActions';
import ConfirmChangesModal from '../../../shared-components/detailed-availability/ConfirmChangesModal';

import { PERMIT_COMPLETE } from '../../constants';
import { issuanceStatuses } from '../../utils/utilsNew';

export default class BookNow extends React.Component {
    static propTypes = {
        hasExistingReservation: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isLoading: PropTypes.bool,
        numItineraryItems: PropTypes.number,
        onCancelClick: PropTypes.func.isRequired,
        onSaveClick: PropTypes.func.isRequired,
        issuanceStatus: PropTypes.number,
        hasNYRInLegend: PropTypes.bool,
        hasWalkupInLegend: PropTypes.bool,
    };

    static defaultProps = {
        hasExistingReservation: false,
        isDisabled: false,
        isLoading: false,
        numItineraryItems: 0,
        hasNYRInLegend: false,
        hasWalkupInLegend: true,
    };

    state = {
        modalOpen: false,
    };

    openModal = () => {
        this.setState({ modalOpen: true });
    };

    closeModal = () => {
        this.setState({ modalOpen: false });
    };

    render() {
        const {
            hasExistingReservation,
            isDisabled,
            isLoading,
            numItineraryItems,
            onCancelClick,
            onSaveClick,
            issuanceStatus,
            hasNYRInLegend,
            hasWalkupInLegend,
        } = this.props;

        const isExistingIssuanceValid =
            hasExistingReservation &&
            issuanceStatus === issuanceStatuses.get(PERMIT_COMPLETE);

        return (
            <DetailedAvailabilityActions key={numItineraryItems}>
                <AvailabilityTypes
                    legendItems={{
                        available: false,
                        availableNumber: true,
                        walkup: hasWalkupInLegend,
                        lottery: true,
                        unavailable: true,
                        notYetReleased: hasNYRInLegend,
                    }}
                />
                {hasExistingReservation && (
                    <Button
                        appearance="tertiary"
                        onClick={onCancelClick}
                        className="rec-button-tertiary"
                    >
                        Cancel Changes
                    </Button>
                )}
                <Button
                    onClick={isExistingIssuanceValid ? this.openModal : onSaveClick}
                    isDisabled={!!isDisabled || isLoading}
                    isLoading={isLoading}
                >
                    {hasExistingReservation ? 'Save Changes' : 'Book Now'}
                </Button>
                <ConfirmChangesModal
                    isOpen={this.state.modalOpen}
                    onClose={this.closeModal}
                    onConfirm={this.props.onSaveClick}
                    isLoading={isLoading}
                    isDisabled={isDisabled}
                />
            </DetailedAvailabilityActions>
        );
    }
}
